import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import stateBg from '../../../images/Group 1.png';
import leftBg from '../../../images/Vector 68.png';
import rightBg from '../../../images/Vector 67.png';
import fullBg from '../../../images/statsBg.png';
import './Stats.css'

const stateTextBg = {
    backgroundImage: `url(${stateBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}
const stateLeftBg = {
    backgroundImage: `url(${leftBg})`,
    backgroundPosition: 'left bottom',
    backgroundRepeat: 'no-repeat',
    marginLeft: '2%'
}
const stateRightBg = {
    backgroundImage: `url(${rightBg})`,
    backgroundPosition: 'right 2% bottom 10%',
    backgroundRepeat: 'no-repeat'
}
const fullStateBg = {
    backgroundImage: `url(${fullBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat'
}

const Stats = () => {
    return (
        <>
            <div style={stateRightBg}>
                <Container>
                    <Box style={stateTextBg} sx={{ textAlign: 'left' }}>
                        <Typography variant="h6" id="stats-start" sx={{ color: '#0015D1', textDecoration: 'underline', fontWeight: 600, fontSize: '35px', pt: '2%' }}>
                            Stats
                        </Typography>
                        <Typography variant="h3" id="stats-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600 }}>
                            Some Counts That Matters
                        </Typography>
                    </Box>
                </Container>
                <Box style={fullStateBg}>
                    <Box style={stateLeftBg}>
                        <Container sx={{ pt: 3, pb: 7 }}>
                            <Grid container>
                                <Grid item xs={6} md={3} id="card-hover">
                                    <Box id="box-shadow" sx={{ backgroundColor: '#FFFFFF', borderRadius: 1, mr: 2, mb: 2 }}>
                                        <Typography variant="h4" sx={{ pt: 1, color: '#FF5358', fontWeight: 700 }}>
                                            50+
                                        </Typography>
                                        <Typography variant="body1" id="state-message" sx={{ pt: 1, pb: 3, color: '#5B5B5B' }}>
                                            Projects Delivered
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <Box id="box-shadow" sx={{ backgroundColor: '#FFFFFF', borderRadius: 1, mr: 2, mb: 2 }}>
                                        <Typography variant="h4" sx={{ pt: 1, color: '#FF5358', fontWeight: 700 }}>
                                            50+
                                        </Typography>
                                        <Typography variant="body1" id="state-message" sx={{ pt: 1, pb: 3, color: '#5B5B5B' }}>
                                            Satisfied Clients
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <Box id="box-shadow" sx={{ backgroundColor: '#FFFFFF', borderRadius: 1, mr: 2 }}>
                                        <Typography variant="h4" sx={{ pt: 1, color: '#FF5358', fontWeight: 700 }}>
                                            5+
                                        </Typography>
                                        <Typography variant="body1" id="state-message" sx={{ pt: 1, pb: 3, color: '#5B5B5B' }}>
                                            Service Categories
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <Box id="box-shadow" sx={{ backgroundColor: '#FFFFFF', borderRadius: 1, mr: 2 }}>
                                        <Typography variant="h4" sx={{ pt: 1, color: '#FF5358', fontWeight: 700 }}>
                                            20+
                                        </Typography>
                                        <Typography variant="body1" id="state-message" sx={{ pt: 1, pb: 3, color: '#5B5B5B' }}>
                                            Dedicated Team
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>
                </Box>
            </div>
        </>
    );
};

export default Stats;